/**
 * tn.common - re-usable components and services
 *
 * This module must not include any views or application specific components.
 * This module must not have any dependencies on application modules.
 */

import angular from 'angular';
import 'angular-rangeslider';
import { GtmService } from './classes/gtm/GtmService';

import {
    BuySaveButtonComponent,
    DesktopTrialButtonComponent,
    DesktopTrialPopoverComponent,
    DesktopTrialPopoverFormComponent,
    DesktopTrialPopoverSuccessComponent,
    FamilySpecimenComponentOptions,
    FamilySpecimenHeadingComponentOptions,
    OAuthPostLogoutRedirectUriComponentOptions,
    OAuthRedirectUriComponentOptions,
    PopoverLoginComponent,
    RawSpecimenComponentOptions,
    SpecimenComponentOptions,
    SpecimensGroupComponentOptions,
    StyleSpecimenComponentOptions,
    StyleSpecimenHeadingComponentOptions,
    TnCheckboxesComponent,
    TnComboboxComponentOptions,
    TnDateSelect2ComponentOptions,
    TnFieldGroupComponent,
    TnSelect2ComponentOptions,
    TnSelect3ComponentOptions,
    VariableAxisSliderComponentOptions,
    VariableInstanceSelectComponentOptions,
    VariableSpecimen2ComponentOptions,
    VariableSpecimenComponentOptions,
} from './components';

import { rangeFilter, startFromFilter } from './filters';
import {
    FontFamilyPublicRepository,
    FontFamilyPublicService,
    FontFamilyRepository,
    FontFamilyService,
    FontStylePublicRepository,
    FontStylePublicService,
    FontStyleRepository,
    FontStyleService,
    FoundryService,
    OrderRepository,
    OrderService,
    ScrollService,
    SpecimenService,
    TrialService,
} from './providers';

export default angular
    .module('tn.common', ['ui-rangeSlider'])
    // auth
    .component('oauthRedirectUri', OAuthRedirectUriComponentOptions)
    .component(
        'oauthPostLogoutRedirectUri',
        OAuthPostLogoutRedirectUriComponentOptions
    )
    .component('popoverLogin', PopoverLoginComponent)

    .component('desktopTrialButton', DesktopTrialButtonComponent)
    .component('desktopTrialPopover', DesktopTrialPopoverComponent)
    .component('desktopTrialPopoverForm', DesktopTrialPopoverFormComponent)
    .component(
        'desktopTrialPopoverSuccess',
        DesktopTrialPopoverSuccessComponent
    )

    // input
    .component('tnCheckboxes', TnCheckboxesComponent)
    .component('tnFieldGroup', TnFieldGroupComponent)
    .component('tnCombobox', TnComboboxComponentOptions)
    .component('tnDateSelect2', TnDateSelect2ComponentOptions)
    .component('tnSelect2', TnSelect2ComponentOptions)
    .component('tnSelect3', TnSelect3ComponentOptions)

    // specimen
    .component('buySaveButtons', BuySaveButtonComponent)
    .component('familySpecimen', FamilySpecimenComponentOptions)
    .component('familySpecimenHeading', FamilySpecimenHeadingComponentOptions)
    .component('specimen', SpecimenComponentOptions)
    .component('specimenRaw', RawSpecimenComponentOptions)
    .component('specimensGroup', SpecimensGroupComponentOptions)
    .component('styleSpecimen', StyleSpecimenComponentOptions)
    .component('styleSpecimenHeading', StyleSpecimenHeadingComponentOptions)
    .component('variableAxisSlider', VariableAxisSliderComponentOptions)
    .component('variableInstanceSelect', VariableInstanceSelectComponentOptions)
    .component('variableSpecimen', VariableSpecimenComponentOptions)
    .component('variableSpecimen2', VariableSpecimen2ComponentOptions)

    // filters
    .filter('range', rangeFilter)
    .filter('startFrom', startFromFilter)

    // providers
    // GtmService is in classes, but used as a service becuase nothing is injected.
    .service('gtmService', GtmService)
    .service('FontFamilyPublicRepository', FontFamilyPublicRepository)
    .service('FontFamilyPublicService', FontFamilyPublicService)
    .service('FontFamilyRepository', FontFamilyRepository)
    .service('FontFamilyService', FontFamilyService)
    .service('FontStylePublicRepository', FontStylePublicRepository)
    .service('FontStylePublicService', FontStylePublicService)
    .service('FontStyleRepository', FontStyleRepository)
    .service('FontStyleService', FontStyleService)
    .service('foundryService', FoundryService)
    .service('orderRepository', OrderRepository)
    .service('orderService', OrderService)
    .service('$scroll', ScrollService)
    .service('specimenService', SpecimenService)
    .service('trialService', TrialService).name;

// re-exports from child folders to keep import statements short.
export * from './classes';
export * from './components';
export * from './constants';
export * from './directives';
export * from './filters';
export * from './functions';
export * from './providers';
export * from './types';
